<template>
  <div class="relative min-h-screen">
    <div class="h-80 bg-bgheader w-full absolute top-0 left-0 z-0"></div>
    <div class="relative z-10 pt-10 pb-10">
      <div class="flex flex-col justify-center">
        <h1 class="text-right text-lg font-bold mb-6 pt-6 mr-5 text-white">
          لیست مجوز ها
        </h1>
        <div
          class="block bg-white rounded-xl px-3 py-4 border text-cyan-900 text-sm mt-2 mx-4 shadow"
          v-if="permissionOutput.length != 0"
        >
          <div
            v-for="perm in permissionOutput"
            :key="perm.perm_Id"
            class="mb-2 rounded-md hover:bg-gray-50 transition cursor-pointer"
            @click="openDetail(perm.perm_Id)"
          >
            <div class="flex flex-col gap-y-1">
              <div class="flex items-center">
                <font-awesome-icon
                  icon="fa-solid fa-list-ol"
                  class="ml-2 text-bgbutton text-base"
                />
                <span class="font-bold w-24">شماره مجوز:</span>
                <span>{{ perm.perm_Sho }}</span>
              </div>

              <div class="flex items-center">
                <font-awesome-icon
                  icon="fa-solid fa-id-card"
                  class="ml-2 text-bgbutton text-base"
                />
                <span class="font-bold w-24">نام راننده:</span>
                <span>{{ perm.driver_Name }}</span>
              </div>

              <div class="flex items-center">
                <font-awesome-icon
                  icon="fa-solid fa-square-phone-flip"
                  class="ml-2 text-bgbutton text-base"
                />
                <span class="font-bold w-24">تلفن راننده:</span>
                <span>{{ perm.driver_Tel }}</span>
              </div>

              <div class="flex items-center">
                <font-awesome-icon
                  icon="fa-solid fa-truck-moving"
                  class="ml-2 text-bgbutton text-base"
                />
                <span class="font-bold w-24">نوع ماشین:</span>
                <span>{{ perm.kind_Machin }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="block bg-white rounded-2xl px-4 py-11 border text-cyan-900 text-center text-lg mt-4 mx-4 shadow-lg h-36"
          v-else
        >
          <span class="text-red-800 font-bold"
            >داده ای برای نمایش وجود ندارد</span
          >
        </div>
        <div v-if="permissionOutput.length > 5">
          <v-pagination
            v-model="pagination.pageNumber"
            :pages="pagination.totalPages"
            :range-size="1"
            active-color=""
            @update:modelValue="getPermissionOutput"
          />
        </div>
        <!-- نمایش کامپوننت CartRadioGroup بعد از لیست مجوزها -->
      </div>
    </div>
  </div>
  <transition name="fade">
    <div
      class="fixed h-screen w-screen top-0 bg-gray-500/50 z-30"
      v-if="showCartDetail"
      @click="closeCartDetail"
    >
      <div
        class="bg-slate-200 rounded-lg w-3/4 mt-[30%] mx-auto p-6 h-auto"
        @click.stop
      >
        <div>
          <div class="flex flex-col space-y-2">
            <h3 class="text-center text-base font-bold pt-2 text-cyan-900">
              لیست سبد خریدها
            </h3>
            <div class="max-h-96 overflow-y-auto space-y-2 px-2">
              <div
                v-for="detail in selectedCartDetails"
                :key="detail.basket_Id"
                :class="[
                  'rounded-md p-2 text-xs transition-all duration-200 flex gap-y-1 flex-col',
                  flgSabadMap[detail.basket_Id]
                    ? 'bg-green-100 border-2 border-bggreen'
                    : 'bg-white border border-gray-300',
                ]"
              >
                <!-- شماره سبد خرید -->
                <div class="flex items-center">
                  <font-awesome-icon
                    icon="fa-cart-shopping"
                    class="ml-1 text-bgbutton text-base"
                  />
                  <p class="font-bold text-gray-900 ml-1">شماره سبد خرید :</p>
                  <span class="mr-1 text-gray-800">{{ detail.basket_Id }}</span>
                </div>
                <div class="flex items-center">
                  <font-awesome-icon
                    icon="circle-user"
                    class="ml-1 text-bgbutton text-base"
                  />
                  <p class="font-bold text-gray-900 ml-1 mr-1">نام مشتری :</p>
                  <span class="mr-1 text-gray-800">{{
                    detail.customerName
                  }}</span>
                </div>

                <!-- شماره مشتری (قابل کلیک) -->
                <a
                  class="flex items-center rounded-md cursor-pointer no-underline"
                  :class="
                    flgConfirmMap[detail.basket_Id]
                      ? 'bg-green-100 py-1'
                      : 'py-1'
                  "
                  :href="`tel:${detail.mobile}`"
                  @click="
                    ($event) =>
                      handleCallClick(
                        $event,
                        detail.basket_Id,
                        detail.perm_Id,
                        detail.order_Sho
                      )
                  "
                >
                  <font-awesome-icon
                    icon="fa-square-phone-flip"
                    class="ml-2 text-bgbutton text-base"
                  />
                  <p class="font-bold text-gray-900 ml-1">شماره مشتری :</p>
                  <span class="mr-1 text-gray-800">{{ detail.mobile }}</span>

                  <!-- تیک تماس اگر انجام شده -->
                  <font-awesome-icon
                    v-if="flgConfirmMap[detail.basket_Id]"
                    icon="fa-check-circle"
                    class="ml-auto text-bggreen text-sm mr-5"
                  />
                </a>

                <!-- چک تایید برای بارگیری -->
                <div
                  class="flex items-center cursor-pointer transition-all duration-300 rounded-md"
                >
                  <label
                    class="flex items-center w-full cursor-pointer"
                    :for="`approve-${detail.basket_Id}`"
                  >
                    <input
                      type="checkbox"
                      class="ml-2"
                      :id="`approve-${detail.basket_Id}`"
                      :checked="flgSabadMap[detail.basket_Id]"
                      @change="
                        toggleApproval(
                          detail.basket_Id,
                          detail.perm_Id,
                          detail.order_Sho
                        )
                      "
                    />
                    <p class="font-bold text-gray-900 select-none">
                      تایید برای بارگیری
                    </p>
                  </label>
                </div>
              </div>
            </div>
              <v-pagination
                v-model="pagination.pageNumber"
                :pages="pagination.totalPages"
                :range-size="1"
                active-color=""
                @update:modelValue="getReportCustomer"
              />
  
          </div>
        </div>
        <!-- <CartRadioGroup
          :details="selectedCartDetails"
          :pagination="pagination"
          @page-changed="getReportCustomer"
        /> -->
      </div>
    </div>
  </transition>
</template>
<script>
import VPagination from "@hennge/vue3-pagination";
import "../../assets/css/pagination.css";
import { getReportCustomer, updatePermissionOutput } from "../../API/API";
//import CartRadioGroup from "@/components/CartRadioGroup.vue";

export default {
  name: "ReportCustomer",
  components: { VPagination },
  data() {
    return {
      requests: [],
      customerId: "",
      ordersho: "",
      permSho: "",
      permissionOutput: [],
      showCartDetail: false,
      selectedCartDetails: [],
      pagination: { pageNumber: 1, totalPages: 1 },

      selected: [], // شماره سبدهایی که روشون کلیک شده
      approved: [], // تاییدشده‌ها
      flags: { flg_Sab: 0, flg_Cnfrm: 0 },
      permId: "",
      flgConfirmMap: {}, // وضعیت فلگ تماس به تفکیک سبد
      flgSabadMap: {},
      modelValue: {
        type: Array,
        default: () => [],
      },
    };
  },
  created() {
    this.getReportCustomer(1);
  },
  methods: {
    initFlags() {
      this.details.forEach((item) => {
        this.flgSabadMap[item.basket_Id] = item.flg_Sab === 1;
        this.flgConfirmMap[item.basket_Id] = item.flg_Cnfrm === 1;
      });
    },
    closeCartDetail() {
      this.showCartDetail = false;
    },
    async getReportCustomer(pageNumber = 1) {
      this.selectedCartDetails = [];
      this.requests = (
        await getReportCustomer(
          pageNumber,
          this.customerId,
          this.ordersho,
          this.permSho
        )
      ).data.result;
      this.permissionOutput = [];
      this.permissionOutput = this.requests.data;
      this.pagination = {};
      this.pagination = this.requests.pagination;
      if (this.showCartDetail) {
        let id = localStorage.getItem("permId");
        const selected = this.permissionOutput.find((p) => p.perm_Id === id);
        if (selected && selected.permissionOutputQueryResponses) {
          this.selectedCartDetails = [
            ...selected.permissionOutputQueryResponses,
          ];
        }
      }
    },
    openDetail(permId) {
      localStorage.setItem("permId", permId);
      const selected = this.permissionOutput.find((p) => p.perm_Id === permId);
      if (selected && selected.permissionOutputQueryResponses) {
        this.selectedCartDetails = [...selected.permissionOutputQueryResponses];
        this.showCartDetail = true;
      }
    },
    handleCallClick(event, id, permId, ordersho) {
      this.permId = permId;
      this.ordersho = ordersho;

      const isSelected = this.flgConfirmMap[id] === true;

      if (!isSelected) {
        this.flgConfirmMap[id] = true;
      } else {
        event.preventDefault();
        this.flgConfirmMap[id] = false;
      }

      const flags = {
        flg_Cnfrm: this.flgConfirmMap[id] ? 1 : 0,
        flg_Sab: this.flgSabadMap[id] ? 1 : 0,
      };

      this.callUpdateApi(flags);
    },
    callUpdateApi(flags) {
      updatePermissionOutput(this.permId, this.ordersho, flags)
        .then((rsp) => {
          console.log(rsp);
          this.$swal({
            icon: "success",
            title: "موفق",
            text: "بروزرسانی با موفقیت انجام شد",
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "خطا",
            text: "عملیات با شکست مواجه شد",
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        });
    },
    toggleApproval(id, permId, ordersho) {
      this.permId = permId;
      this.ordersho = ordersho;

      const isApproved = this.flgSabadMap[id] === true;
      this.flgSabadMap[id] = !isApproved;

      const flags = {
        flg_Cnfrm: this.flgConfirmMap[id] ? 1 : 0,
        flg_Sab: this.flgSabadMap[id] ? 1 : 0,
      };

      this.callUpdateApi(flags);
    },
  },
  watch: {
    modelValue(newVal) {
      this.selected = [...newVal];
    },
    selected(newVal) {
      this.$emit("update:modelValue", newVal);
    },
  },
};
</script>
